/*
 * @Descripttion: 过滤条件
 * @Author: zenghua.wang
 * @Date: 2021-08-31 15:18:02
 * @LastEditors: zenghua.wang
 * @LastEditTime: 2021-12-24 09:14:22
 */
export default {
  inject: ['main'],
  data() {
    return {
      filterLoading: false,
      filterDialog: {
        show: false,
        title: '',
        action: 'add',
        index: 0
      },
      filterColumn: [],
      widgets: []
    }
  },
  methods: {
    getConditionWidgets() {
      this.widgets = []
      this.main.data.list.map((item) => {
        if (item.type === 'condition') {
          this.widgets.push({
            label: item.label,
            value: item.prop,
            disabled: false,
            list: item.option.column || []
          })
        }
      })
    },
    addFilter(column = [], isApi = true) {
      if (!this.data.apiId && isApi) {
        this.$notify.error({
          title: '错误',
          message: '请先选择其中一条apis数据'
        })
      } else {
        this.filterColumn = column
        this.filterDialog = {
          show: true,
          title: '新增',
          action: 'add',
          index: null
        }
      }
    },
    editFilter(row, index) {
      this.getConditionWidgets()
      this.filterColumn = row
      this.filterDialog = {
        show: true,
        title: '编辑',
        action: 'edit',
        index: index
      }
    },
    updateFilter(val) {
      this.$set(this.data.option, 'reqParams', val)
      this.filterColumn = []
    },
    deleteFilter(row, index) {
      this.data.option.reqParams.splice(index, 1)
    }
  }
}
